var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('Menu',{ref:"top-menu"}),_c('router-view',{key:_vm.$route.fullPath})],1)])])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }